export default "__VITE_ASSET__B2Draivh__"